export default __webpack_public_path__ + "static/media/sbarro_pizza.c255e150.png";